export default __webpack_public_path__ + "static/media/benefit_3@3x.08f82f2b.png";